import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"rocket"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5.63574 12.7062L11.2926 18.3631L19.5561 10.0996C21.0563 8.59932 21.8992 6.56449 21.8992 4.44275V2.09961H19.5561C17.4343 2.09961 15.3995 2.94246 13.8992 4.44275L5.63574 12.7062Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M17.6569 18.3632L16.9498 12.7063L11.293 18.3632L14.4749 21.5451L17.6569 18.3632Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M5.63608 6.34229L11.2929 7.04939L5.63608 12.7062L2.4541 9.52427L5.63608 6.34229Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4.22191 16.9489L2.10059 19.0702M7.05003 19.7773L4.92871 21.8987M17.6569 18.3632L16.9498 12.7063L11.293 18.3632L14.4749 21.5451L17.6569 18.3632ZM5.63608 6.34229L11.2929 7.04939L5.63608 12.7062L2.4541 9.52427L5.63608 6.34229Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.2926 7.04936L5.63574 12.7062M5.63574 12.7062L11.2926 18.3631M5.63574 12.7062L13.8992 4.44275C15.3995 2.94246 17.4343 2.09961 19.5561 2.09961H21.8992V4.44275C21.8992 6.56449 21.0563 8.59932 19.5561 10.0996L11.2926 18.3631M16.9494 12.7062L11.2926 18.3631","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Rocket = Vue.extend<IconProps>({
  name: 'RocketIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'rocket',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Rocket;
